import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from 'src/app/core/services/configuration.service';

@Pipe({
  name: 'datetimeFormat',
  standalone: true
})
export class DatetimeFormatPipe implements PipeTransform {
  constructor(private configService: ConfigurationService) { }
  transform(value: string): string {
    const parsedDate = new Date(value);
    const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
    const formattedDate = parsedDate.toLocaleString('en-US', options).replace(',', '');
    const parts = formattedDate.split(' ');
    parts[2] = parts[2].replace(/,/g, '');
    const formattedWithSpace = parts[0] + ' ' + parts[1] + ', ' + parts[2] + ' ' + parts[3] + ' ' + parts[4];
    return formattedWithSpace;
  }

}
